import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  downloadAllConsumables({ commit }) {
    return new Promise((resolve, reject) => {
      API.consumables.downloadAll(
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchConsumables({ commit }) {
    return new Promise((resolve, reject) => {
      API.consumables.getConsumables(
        resp => {
          let consumables = resp.data.data;
          resolve(consumables);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },
  fetchAllMaps({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.consumables.getAll(
        queryParams,
        "",
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getConsumablesWMS({ commit }) {
    return new Promise((resolve, reject) => {
      API.consumables.getConsumablesWMS(
        resp => {
          let consumables = resp.data.data;
          resolve(consumables);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },
  fetchConsumablesById({ commit }, consumablesId) {
    return new Promise((resolve, reject) => {
      API.consumables.getConsumablesById(
        consumablesId,
        resp => {
          let consumables = resp.data.data[0];
          resolve(consumables);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },
  editConsumables({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.consumables.editConsumables(
        newData,
        resp => {
          let consumable = resp.data.data;
          resolve(consumable);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createConsumables({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.consumables.createConsumables(
        newData,
        resp => {
          let consumable = resp.data.data;
          resolve(consumable);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteConsumables({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.consumables.deleteConsumables(
        newData,
        resp => {
          let consumable = resp.data.data;
          resolve(consumable);
        },
        error => {
          reject(error);
        }
      );
    });
  },

};

  export default { state, getters, actions, mutations };


// WEBPACK FOOTER //
// ./src/store/modules/consumables.js